<template>
  <el-form ref="searchForm" :model="searchForm" class="search-form">
    <div v-for="(item, index) in searchList" :key="index">
      <!-- 输入框 -->
      <el-form-item v-if="!item.isHide && item.type === 'input'" :label="item.text" :prop="item.id" class="form-item">
        <el-input v-model="searchForm[item.id]" :maxlength="item.maxlength || 200" :placeholder="item.placeholder"
                  class="input" :style="{'width': item.width || '160px'}" />
      </el-form-item>
      <el-form-item v-if="!item.isHide && item.type === 'inputId'" :label="item.text" :prop="item.id" class="form-item">
        <el-input v-model="searchForm[item.id]" :placeholder="item.placeholder" class="input" type="number"/>
      </el-form-item>
      <!-- 选择输入框 -->
      <el-form-item v-if="!item.isHide && item.type === 'select'" :label="item.text" :prop="item.id" class="form-item">
        <template v-if="item.id === 'promoteCode'">
          <el-select v-model="searchForm[item.id]" :placeholder="item.placeholder">
            <el-option v-for="item in promoteList" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </template>
        <template v-else-if="item.id === 'status'">
          <el-select v-model="searchForm[item.id]" :placeholder="item.placeholder" clearable>
            <el-option v-for="item in optionsStatus" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </template>
        <template v-else-if="item.id === 'refundStatus'">
          <el-select v-model="searchForm[item.id]" :placeholder="item.placeholder" clearable>
            <el-option v-for="item in refundOptions" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </template>
        <template v-else-if="item.id === 'couponTypeId'">
          <el-select v-model="searchForm[item.id]" :placeholder="item.placeholder" clearable>
            <el-option v-for="item in optionsTypeCoupon" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </template>
        <template v-else-if="item.id === 'isOrdered'">
          <el-select v-model="searchForm[item.id]" :placeholder="item.placeholder" clearable>
            <el-option v-for="item in isOrderedOptions" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </template>
        <template v-else>
          <el-select v-model="searchForm[item.id]" :placeholder="item.placeholder">
            <el-option v-for="item in item.optionsType || optionsType" :key="item.value" :label="item.label"
                       :value="item.value"/>
          </el-select>
        </template>
      </el-form-item>
      <!-- 时间选择框 -->
      <el-form-item v-if="!item.isHide && item.type === 'time'" :label="item.text" :prop="item.id"
                    style="width: 350px">
        <el-date-picker v-model="searchForm[item.id]" :clearable="true" :default-time="['00:00:00', '23:59:59']"
                        end-placeholder="年/月/日"
                        format="yyyy-MM-dd" range-separator="-" start-placeholder="年/月/日" style="width: 280px"
                        type="daterange" value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions('time')"
                        @blur="blur('time')"
                        @change="getTime"/>
      </el-form-item>
      <el-form-item v-if="!item.isHide && item.type === 'operateTime'" :label="item.text" :prop="item.id"
                    style="width: 350px">
        <el-date-picker v-model="searchForm[item.id]" :clearable="true" :default-time="['00:00:00', '23:59:59']"
                        end-placeholder="年/月/日"
                        format="yyyy-MM-dd" range-separator="-" start-placeholder="年/月/日" style="width: 280px"
                        type="daterange" value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions('operateTime')"
                        @blur="blur('operateTime')"
                        @change="getOperateTime"/>
      </el-form-item>
      <el-form-item v-if="item.isHide  && item.type === 'time'" :label="item.text" :prop="item.id" style="width: 350px">
        <el-date-picker v-model="searchForm[item.id]" :clearable="true" :default-time="['00:00:00', '23:59:59']"
                        end-placeholder="年/月/日"
                        format="yyyy-MM-dd" range-separator="-" start-placeholder="年/月/日" style="width: 280px"
                        type="daterange" value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions('time')"
                        @blur="blur('time')"
                        @change="getTime"/>
      </el-form-item>
      <el-form-item v-if="item.isHide && item.type === 'timeOrder'" :label="item.text" :prop="item.id"
                    style="width: 350px">
        <el-date-picker v-model="searchForm[item.id]" :clearable="true" :default-time="['00:00:00', '23:59:59']"
                        end-placeholder="年/月/日"
                        format="yyyy-MM-dd" range-separator="-" start-placeholder="年/月/日" style="width: 280px"
                        type="daterange" value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions('timeOrder')"
                        @blur="blur('timeOrder')"
                        @change="getTimeOrder"/>
      </el-form-item>
      <el-form-item v-if="item.type === 'useTime'" :label="item.text" :prop="item.id"
                    style="width: 350px">
        <el-date-picker v-model="searchForm[item.id]" :clearable="true" :default-time="['00:00:00', '23:59:59']"
                        end-placeholder="年/月/日"
                        format="yyyy-MM-dd" range-separator="-" start-placeholder="年/月/日" style="width: 280px"
                        type="daterange" value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions('useTime')"
                        @blur="blur('useTime')"
                        @change="getUseTime"/>
      </el-form-item>
      <el-form-item v-if="item.type === 'startTimeArr'" :label="item.text" :prop="item.id"
                    style="width: 350px">
        <el-date-picker v-model="searchForm[item.id]" :clearable="true" :default-time="['00:00:00', '23:59:59']"
                        end-placeholder="年/月/日"
                        format="yyyy-MM-dd" range-separator="-" start-placeholder="年/月/日" style="width: 280px"
                        type="daterange" value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions('startTimeArr')"
                        @blur="blur('startTimeArr')"
                        @change="getStartTime"/>
      </el-form-item>
      <el-form-item v-if="item.type === 'receiveTime'" :label="item.text" :prop="item.id"
                    style="width: 350px">
        <el-date-picker v-model="searchForm[item.id]" :clearable="true" :default-time="['00:00:00', '23:59:59']"
                        end-placeholder="年/月/日"
                        format="yyyy-MM-dd" range-separator="-" start-placeholder="年/月/日" style="width: 280px"
                        type="daterange" value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions('receiveTime')"
                        @blur="blur('receiveTime')"
                        @change="getReceiveTime"/>
      </el-form-item>
      <el-form-item v-if="item.isHide && item.type === 'getTime'" :label="item.text" :prop="item.id"
                    style="width: 350px">
        <el-date-picker v-model="searchForm[item.id]" :clearable="true" :default-time="['00:00:00', '23:59:59']"
                        end-placeholder="年/月/日"
                        format="yyyy-MM-dd" range-separator="-" start-placeholder="年/月/日" style="width: 280px"
                        type="daterange" value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions('getTime')"
                        @blur="blur('getTime')"
                        @change="getGetTime"/>
      </el-form-item>
      <el-form-item v-if="item.isHide && item.type === 'selectType'" :label="item.text" :prop="item.id"
                    style="width: 450px; margin-left: 10px">
        <el-radio-group v-model="searchForm.orderType" style="margin-left: 10px" @input="selectType">
          <el-radio :label="''">全部</el-radio>
          <el-radio :label="1">特惠单</el-radio>
          <el-radio :label="3">秒出单</el-radio>
        </el-radio-group>
      </el-form-item>
    </div>
    <el-form-item>
      <!-- 操作按钮 -->
      <el-button :loading="loading" type="warning" @click="onFormSearch">查询</el-button>
      <el-button plain type="warning" @click="onFormReset">重置</el-button>
      <el-button v-if="!hiddenExport" :loading="exportLoading" @click="onFormExport">导出数据</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {matchInteger, matchMobile} from "@/utils/regExp";
import debounce from '@/utils/debounce.js'
import { mapState } from 'vuex'

export default {
  name: "Index",
  props: [
    "searchList",
    "searchForm",
    "optionsType",
    "optionsStatus",
    "promoteList",
    "isRenewOption",
    "isAccount",
    "hiddenExport",
    "refundOptions",
    "optionsTypeCoupon",
    "loading",
    "exportLoading",
    "isOrderedOptions"
  ],
  computed: {
    // ...mapState('user', ['isHoliday'])
    isHoliday() {
      return this.$store.getters.isHoliday
    },
  },
  data() {
    return {
      options: [
        {
          label: "1",
          value: "1",
        },
      ],
      haveExport: true,
      pickerStateMap:{}
    };
  },
  mounted() {
    if (this.isAccount === 1) {
      this.haveExport = false;
    }
  },
  methods: {
    // 限制时间范围
    pickerOptions(key) {
      if (!this.pickerStateMap[key]) {
        this.$set(this.pickerStateMap, key, {
          tempStartDate: null,
        })
      }
      return {
        onPick: ({minDate, maxDate}) => {
          if(!this.isHoliday) return
          // console.log(minDate, maxDate,'onPickonPick')
          const state = this.pickerStateMap[key]
          // 只选了第一个时间
          if (minDate && !maxDate) {
            state.tempStartDate = minDate
          }
          // 选完 or 清空
          if (!minDate && !maxDate) {
            state.tempStartDate = null
          }
        },
        disabledDate: (time) => {
          if(!this.isHoliday) return
          // console.log(time,'disabledDatedisabledDate',this.isHoliday)
          const state = this.pickerStateMap[key]
          if (!state.tempStartDate) {
            return false
          }
          const day = 31
          const sixMonth = day * 24 * 3600 * 1000
          const startTime = state.tempStartDate.getTime()

          return (
            time.getTime() <= startTime - sixMonth ||
            time.getTime() >= startTime + sixMonth
          )
        }
      }
    },
    blur(key) {
      console.log(key,'blur==',this.isHoliday)
      // this.tempStartDate = null
      this.pickerStateMap[key].tempStartDate = null
    },
    // 搜索
    onFormSearch() {
      // 验证订单号
      debounce(() => {
        if (
          this.$parent.searchForm.orderId &&
          this.$parent.searchForm.orderId.length
        ) {
          if (!matchInteger.test(this.$parent.searchForm.orderId)) {
            this.$message.error("请输入正确的订单号");
            return;
          }
        }

        // 验证用户ID
        if (this.$parent.searchForm.id && this.$parent.searchForm.id.length) {

          if (!matchInteger.test(this.$parent.searchForm.id)) {
            this.$message.error("请输入正确的用户ID");
            return;
          }
        }

        // 验证推荐人ID
        if (
          this.$parent.searchForm.parentId &&
          this.$parent.searchForm.parentId.length
        ) {
          if (!matchInteger.test(this.$parent.searchForm.parentId)) {
            this.$message.error("请输入正确的推荐人ID");
            return;
          }
        }
        // 验证交易订单号
        if (
          this.$parent.searchForm.withdrawNo &&
          this.$parent.searchForm.withdrawNo.length
        ) {
          if (!matchInteger.test(this.$parent.searchForm.withdrawNo)) {
            this.$message.error("请输入正确的交易订单号");
            return;
          }
        }


        // 验证手机号
        if (
          this.$parent.searchForm.reservedPhone &&
          this.$parent.searchForm.reservedPhone.length
        ) {
          if (!matchMobile.test(this.$parent.searchForm.reservedPhone)) {
            this.$message.error("请输入正确的手机号码");
            return;
          }
        }


        if (this.$parent.searchForm) {
          this.$parent.searchForm.pageNo = 1;
        }
        this.$parent.getList("reload");
      }, 500, true)

    },
    // 重置
    onFormReset() {
      debounce(() => {
        this.$refs['searchForm'].resetFields();
        this.$parent.searchForm.startCreateTime = "";
        this.$parent.searchForm.endCreateTime = "";
        this.$parent.searchForm.orderCreateEndTime = "";
        this.$parent.searchForm.orderCreateStartTime = "";
        this.$parent.searchForm.orderType = "";
        this.$parent.searchForm.operateBeginTime = "";
        this.$parent.searchForm.operateEndTime = "";
        this.$parent.searchForm.refundStatus = '';
        this.$parent.searchForm.pageNo = 1;
        this.$parent.searchForm.pageSize = 10;
        this.$parent.searchForm.startTime = "";
        this.$parent.searchForm.endTime = "";
        this.$parent.getList("reset");
      }, 500, true)

    },
    getOperateTime(e) {
      console.log(e);
      const status = e && e.length === 2;
      this.$parent.searchForm.operateBeginTime = status ? e[0] : "";
      this.$parent.searchForm.operateEndTime = status ? e[1] : "";
      this.$forceUpdate();
    },
    getTime(e) {
      console.log(e,'getTimegetTime');
      const status = e && e.length === 2;
      this.$parent.searchForm.startCreateTime = status ? e[0] : "";
      this.$parent.searchForm.endCreateTime = status ? e[1] : "";
    },
    getTimeOrder(e) {
      console.log(e);
      const status = e && e.length === 2;
      this.$parent.searchForm.orderCreateStartTime = status ? e[0] : "";
      this.$parent.searchForm.orderCreateEndTime = status ? e[1] : "";
    },
    getUseTime(e) {
      console.log(e,'getUseTimegetUseTimegetUseTime');
      const status = e && e.length === 2;
      this.$parent.searchForm.useTimeStart = status ? e[0] : "";
      this.$parent.searchForm.useTimeEnd = status ? e[1] : "";
    },
    getStartTime(e) {
      console.log(e);
      const status = e && e.length === 2;
      this.$parent.searchForm.startTime = status ? e[0] : "";
      this.$parent.searchForm.endTime = status ? e[1] : "";
    },

    getReceiveTime(e) {
      console.log(e);
      const status = e && e.length === 2;
      this.$parent.searchForm.createTimeStart = status ? e[0] : "";
      this.$parent.searchForm.createTimeEnd = status ? e[1] : "";
    },

    getGetTime(e) {
      console.log(e);
      const status = e && e.length === 2;
      this.$parent.searchForm.getTimeStart = status ? e[0] : "";
      this.$parent.searchForm.getTimeEnd = status ? e[1] : "";
    },
    // 导出
    onFormExport() {
      this.$parent.exportButton();
    },
    // 筛选订单
    selectType(e) {
      this.$parent.searchForm.orderType = e;
      this.$parent.getList();
    },
  },
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/Search/index.vue